import { AGENTS } from '../../lib/agents';
import type { AgentState } from '../../lib/schema';

interface Props {
  readonly states: readonly AgentState[];
  readonly onSelect: (id: (typeof AGENTS)[number]['id']) => void;
}

/** Invisible-to-sighted keyboard + screen-reader layer over the canvas.
 *  Every agent has an equivalent button. Tab navigable. Announces status changes. */
export function KeyboardShadow({ states, onSelect }: Props) {
  return (
    <div
      className="sr-only"
      role="region"
      aria-label="Agent controls"
      style={{
        position: 'absolute',
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: 'hidden',
        clip: 'rect(0,0,0,0)',
        whiteSpace: 'nowrap',
        border: 0,
      }}
    >
      <h2>Agents</h2>
      <ul>
        {AGENTS.map((a) => {
          const state = states.find((s) => s.agentId === a.id);
          return (
            <li key={a.id}>
              <button
                type="button"
                onClick={() => onSelect(a.id)}
                aria-label={`${a.label}, ${a.title}, status ${state?.status ?? 'unknown'}, ${state?.activity ?? ''}`}
              >
                {a.label}
              </button>
            </li>
          );
        })}
      </ul>
      <div aria-live="polite" aria-atomic="false">
        {states.map((s) => (
          <p key={s.agentId}>
            {s.agentId}: {s.status} — {s.activity}
          </p>
        ))}
      </div>
    </div>
  );
}
